export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 2.61daaf79.png";